import React from "react"
import ReactDOM from "react-dom"
import LoginState from "./components/loginState"

export default class LoginStateApplet {
  constructor() {
    this.init()
  }

  init() {
    const loginContainers = document.querySelectorAll("[data-login-state]")
    if (loginContainers) {
      loginContainers.forEach((loginContainer, index) => {
        const config = (loginContainer.dataset.loginState && JSON.parse(loginContainer.dataset.loginState)) || {}
        ReactDOM.render(<LoginState key={index} config={config} />, loginContainer)
      })
    }
  }
}
//window.loginState = new LoginStateApplet()
